<script>

    import { message_ } from "../Services/messages";

    let m_ = null;
    let open = false;

    message_.subscribe((val) => {
        m_ = val;
        if (m_) {
            open = true;
            window.scrollTo(0,0)
            window.setTimeout(() => {
                m_ = null;
                open = false;
            }, 5000);
        }
    });
</script>

<style>
    .message {
        display: none;
        padding: 13px 30px;
        width: 100%;
        height: calc(100% - 26px);
        text-align: center;
        vertical-align: middle;
        background-color: #143b4f;
        color: #fff;
        font-size: 14px;
        font-weight: 400;
    }
    .display {
        display: inline-block;
    }
</style>

<div class="message" class:display={open}  >{ m_ }</div>
